/**
 * Utility functions for conditional discount queries based on parameter settings
 */

/**
 * Returns the select fields for discount queries based on whether coupon codes should be displayed
 * @param shouldDisplayDiscountCode - Whether to include coupon_code field in the query
 * @returns Comma-separated string of fields to select
 */
export const getDiscountSelectFields = (shouldDisplayDiscountCode: boolean): string => {
  const baseFields = [
    'id',
    'business_id', 
    'discount_amount',
    'is_percentage',
    'applies_to_all',
    'is_active',
    'status',
    'type',
    'description',
    'created_at',
    'updated_at'
  ];
  
  // Only include coupon_code if the parameter is enabled
  if (shouldDisplayDiscountCode) {
    baseFields.push('coupon_code');
  }
  
  return baseFields.join(',');
};

/**
 * Type guard to check if discount has coupon_code field
 */
export const hasDiscountCode = (discount: any): discount is { coupon_code: string } => {
  return typeof discount?.coupon_code === 'string';
};